export default "__VITE_ASSET__WqCuIWeZ__"